export const openModal = (modalType, modalData) => ({
  type: 'OPEN_MODAL',
  modalType,
  modalData,
})

export const closeModal = () => ({
  type: 'CLOSE_MODAL',
})

const initialState = {
  isOpen: false,
  modalType: null,
  modalData: undefined,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'OPEN_MODAL':
      return {
        isOpen: true,
        modalType: action.modalType,
        modalData: action.modalData,
      }
    case 'CLOSE_MODAL':
      return { isOpen: false, modalType: '', modalData: undefined }
    default:
      return state
  }
}
